export default __webpack_public_path__ + "static/media/october-2019.d50f3b23.csv";